/**
 * <EmptyRoomNudge>: V4.1.T6-share (funnel, D7).
 *
 * The empty-state invite prompt. When a room has fewer than two players, the
 * owner is staring at an empty room with no obvious next step. This nudge tells
 * them what to do ("share this link to invite them") and surfaces the
 * <ShareLinkCTA> prominently so the share action is one tap away.
 *
 * It renders nothing once a second player has joined, at that point the room
 * is live and the passive share controls elsewhere are enough.
 *
 * Reused by LobbyShell (game rooms) and FreeDrawRoom (free-draw rooms) so there
 * is the one place that defines the empty-room funnel.
 */

import { ShareLinkCTA } from "./ShareLinkCTA.js";
import { InkCat } from "../marks/v1/InkCat.js";

const MIN_PLAYERS_FOR_LIVE_ROOM = 2;

type EmptyRoomNudgeProps = {
  roomId: string;
  playerCount: number;
};

export function EmptyRoomNudge({ roomId, playerCount }: EmptyRoomNudgeProps) {
  if (playerCount >= MIN_PLAYERS_FOR_LIVE_ROOM) return null;

  return (
    <div class="empty-room-nudge" data-testid="empty-room-nudge" role="status" aria-live="polite">
      {/* The mascot waits with you (PRD §5.5, peek pose, idle surface). */}
      <div class="empty-room-nudge__cat">
        <InkCat pose="peek" size={56} />
      </div>
      <p class="empty-room-nudge__headline">Waiting for players — share this link to invite them</p>
      <ShareLinkCTA roomId={roomId} />
    </div>
  );
}
